import React, { useState } from 'react';
import { Container, Row, Col, Card, Table, Badge, Form, Button, InputGroup } from 'react-bootstrap';
import { FaSearch, FaFilter, FaEye, FaTicketAlt } from 'react-icons/fa';
import '../../../../assets/css/admin/dashboardCSS/SupportSystem.css';
import Adminlayout from '../../../../layouts/admin/Adminlayout';
import TitleBar from '../../../../subscreens/admin/TitleBar';
import { Eye } from 'lucide-react';
const SupportTickets = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filterStatus, setFilterStatus] = useState('All');
  const [filterPriority, setFilterPriority] = useState('All');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const tickets = [
    {
      id: '#101',
      user: 'Ali Ahmed',
      role: 'Student',
      category: 'Payment',
      priority: 'High',
      priorityColor: '🔴',
      status: 'Open',
      createdDate: '2025-01-15',
      issue: 'Payment not received yet',
      conversation: [
        { sender: 'User', message: 'Payment not received yet', time: '10:30 AM' },
        { sender: 'Admin', message: 'We are checking your payment status', time: '11:00 AM' }
      ]
    },
    {
      id: '#102',
      user: 'Sara Khan',
      role: 'Donor',
      category: 'Fake Report',
      priority: 'Medium',
      priorityColor: '🟡',
      status: 'In Progress',
      createdDate: '2025-01-14',
      issue: 'Received fake donation request',
      conversation: [
        { sender: 'User', message: 'Someone is using fake profile', time: '09:00 AM' },
        { sender: 'Admin', message: 'We are investigating this case', time: '09:30 AM' }
      ]
    },
    {
      id: '#103',
      user: 'Ahmed Raza',
      role: 'Student',
      category: 'Account',
      priority: 'Low',
      priorityColor: '🟢',
      status: 'Closed',
      createdDate: '2025-01-13',
      issue: 'Cannot login to account',
      conversation: [
        { sender: 'User', message: 'Cannot login to my account', time: '08:00 AM' },
        { sender: 'Admin', message: 'Password reset link sent', time: '08:15 AM' },
        { sender: 'User', message: 'Issue resolved, thank you!', time: '08:30 AM' }
      ]
    }
  ];

  const stats = {
    open: tickets.filter(t => t.status === 'Open').length,
    inProgress: tickets.filter(t => t.status === 'In Progress').length,
    closed: tickets.filter(t => t.status === 'Closed').length
  };

  const filteredTickets = tickets.filter(ticket => {
    const matchesSearch = 
      ticket.id.toLowerCase().includes(searchQuery.toLowerCase()) ||
      ticket.user.toLowerCase().includes(searchQuery.toLowerCase());
    
    const matchesStatus = filterStatus === 'All' || ticket.status === filterStatus;
    const matchesPriority = filterPriority === 'All' || ticket.priority === filterPriority;
    
    return matchesSearch && matchesStatus && matchesPriority;
  });

  const handleViewTicket = (ticket) => {
    setSelectedTicket(ticket);
    setShowDetailModal(true);
  };

  const getStatusBadge = (status) => {
    const variants = {
      'Open': 'danger',
      'In Progress': 'warning',
      'Closed': 'success'
    };
    return variants[status] || 'secondary';
  };

  return (
    <Adminlayout>
    <div className="spt-support-tickets-page">
      <Container fluid>
        
        {/* Page Header */}
        <TitleBar
                title="Support & Tickets"
                subtitle="Manage all user support requests"
              ></TitleBar>

        {/* Stats Cards */}
        <Row className="spt-stats-row mb-4">
          <Col lg={4} md={4} sm={12} className="mb-3">
            <Card className="spt-stat-card spt-open-card">
              <Card.Body>
                <div className="spt-stat-content">
                  <div className="spt-stat-info">
                    <h3 className="spt-stat-value">{stats.open}</h3>
                    <p className="spt-stat-label">Open</p>
                  </div>
                  <div className="spt-stat-icon spt-open-icon">
                    <FaTicketAlt />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={4} sm={12} className="mb-3">
            <Card className="spt-stat-card spt-progress-card">
              <Card.Body>
                <div className="spt-stat-content">
                  <div className="spt-stat-info">
                    <h3 className="spt-stat-value">{stats.inProgress}</h3>
                    <p className="spt-stat-label">In Progress</p>
                  </div>
                  <div className="spt-stat-icon spt-progress-icon">
                    <FaTicketAlt />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={4} md={4} sm={12} className="mb-3">
            <Card className="spt-stat-card spt-closed-card">
              <Card.Body>
                <div className="spt-stat-content">
                  <div className="spt-stat-info">
                    <h3 className="spt-stat-value">{stats.closed}</h3>
                    <p className="spt-stat-label">Closed</p>
                  </div>
                  <div className="spt-stat-icon spt-closed-icon">
                    <FaTicketAlt />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* Filters */}
        <Card className="spt-filter-card mb-4">
          <Card.Body>
            <Row className="align-items-center">
              <Col lg={6} md={12} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="spt-search-icon">
                    <FaSearch />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    placeholder="Search Ticket ID / User..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="spt-search-input"
                  />
                </InputGroup>
              </Col>

              <Col lg={3} md={6} className="mb-3 mb-lg-0">
                <InputGroup>
                  <InputGroup.Text className="spt-filter-icon">
                    <FaFilter />
                  </InputGroup.Text>
                  <Form.Select
                    value={filterStatus}
                    onChange={(e) => setFilterStatus(e.target.value)}
                    className="spt-filter-select"
                  >
                    <option value="All">All Status</option>
                    <option value="Open">Open</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Closed">Closed</option>
                  </Form.Select>
                </InputGroup>
              </Col>

              <Col lg={3} md={6}>
                <InputGroup>
                  <InputGroup.Text className="spt-filter-icon">
                    <FaFilter />
                  </InputGroup.Text>
                  <Form.Select
                    value={filterPriority}
                    onChange={(e) => setFilterPriority(e.target.value)}
                    className="spt-filter-select"
                  >
                    <option value="All">All Priority</option>
                    <option value="High">High</option>
                    <option value="Medium">Medium</option>
                    <option value="Low">Low</option>
                  </Form.Select>
                </InputGroup>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Tickets Table */}
        <Card className="spt-table-card">
          <Card.Body>
            <div className="table-responsive">
              <Table hover className="spt-tickets-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>User</th>
                    <th>Role</th>
                    <th>Category</th>
                    <th>Priority</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTickets.length > 0 ? (
                    filteredTickets.map((ticket) => (
                      <tr key={ticket.id}>
                        <td className="spt-ticket-id">{ticket.id}</td>
                        <td className="spt-user-name">{ticket.user}</td>
                        <td>{ticket.role}</td>
                        <td>{ticket.category}</td>
                        <td>
                          <span className="spt-priority-badge">
                            {ticket.priorityColor} {ticket.priority}
                          </span>
                        </td>
                        <td>
                          <Badge bg={getStatusBadge(ticket.status)}>
                            {ticket.status}
                          </Badge>
                        </td>
                        <td>
                          <button
                            className="spt-action-btn spt-view-btn"
                            onClick={() => handleViewTicket(ticket)}
                            title="View Details"
                          >
                            <Eye size={16} />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center py-4">
                        <p className="spt-no-data">No tickets found</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
          </Card.Body>
        </Card>

      </Container>

      {/* Ticket Detail Modal */}
      {showDetailModal && selectedTicket && (
        <div className="spt-modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="spt-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="spt-modal-header">
              <h3 className="spt-modal-title">Ticket {selectedTicket.id} – {selectedTicket.category} Issue</h3>
              <button className="spt-close-btn" onClick={() => setShowDetailModal(false)}>×</button>
            </div>

            <div className="spt-modal-body">
              <Row>
                {/* Ticket Info */}
                <Col lg={4} md={12} className="mb-4">
                  <Card className="spt-info-card">
                    <Card.Body>
                      <h4 className="spt-section-title">Ticket Info</h4>
                      <div className="spt-info-item">
                        <span className="spt-info-label">User:</span>
                        <span className="spt-info-value">{selectedTicket.user}</span>
                      </div>
                      <div className="spt-info-item">
                        <span className="spt-info-label">Role:</span>
                        <span className="spt-info-value">{selectedTicket.role}</span>
                      </div>
                      <div className="spt-info-item">
                        <span className="spt-info-label">Category:</span>
                        <span className="spt-info-value">{selectedTicket.category}</span>
                      </div>
                      <div className="spt-info-item">
                        <span className="spt-info-label">Priority:</span>
                        <span className="spt-info-value">{selectedTicket.priorityColor} {selectedTicket.priority}</span>
                      </div>
                      <div className="spt-info-item">
                        <span className="spt-info-label">Status:</span>
                        <Badge bg={getStatusBadge(selectedTicket.status)}>{selectedTicket.status}</Badge>
                      </div>
                      <div className="spt-info-item">
                        <span className="spt-info-label">Created:</span>
                        <span className="spt-info-value">{selectedTicket.createdDate}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Conversation */}
                <Col lg={5} md={12} className="mb-4">
                  <Card className="spt-conversation-card">
                    <Card.Body>
                      <h4 className="spt-section-title">Conversation</h4>
                      <div className="spt-conversation-list">
                        {selectedTicket.conversation.map((msg, idx) => (
                          <div key={idx} className={`spt-message ${msg.sender === 'User' ? 'spt-user-msg' : 'spt-admin-msg'}`}>
                            <div className="spt-message-header">
                              <strong>{msg.sender}:</strong>
                              <span className="spt-message-time">{msg.time}</span>
                            </div>
                            <p className="spt-message-text">{msg.message}</p>
                          </div>
                        ))}
                      </div>
                      <div className="spt-reply-box">
                        <Form.Control
                          as="textarea"
                          rows={3}
                          placeholder="Type your reply here..."
                          className="spt-reply-input"
                        />
                        <Button className="spt-send-btn">Send Reply</Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>

                {/* Actions */}
                <Col lg={3} md={12}>
                  <Card className="spt-actions-card">
                    <Card.Body>
                      <h4 className="spt-section-title">Actions</h4>
                      <Form.Group className="mb-3">
                        <Form.Label className="spt-action-label">Status</Form.Label>
                        <Form.Select className="spt-action-select">
                          <option>Open</option>
                          <option>In Progress</option>
                          <option>Closed</option>
                        </Form.Select>
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label className="spt-action-label">Priority</Form.Label>
                        <Form.Select className="spt-action-select">
                          <option>High</option>
                          <option>Medium</option>
                          <option>Low</option>
                        </Form.Select>
                      </Form.Group>

                      <Button className="spt-assign-btn">Assign Admin</Button>
                      <Button className="spt-close-ticket-btn">Close Ticket</Button>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </div>
        </div>
      )}

    </div>
    </Adminlayout>
  );
};

export default SupportTickets;